import { lazy } from 'react'

export const bloxOfferingsByID = [
  {
    name: 'Escolha a oferta',
    component: lazy(() => import('../../modules/public/Offerings')),
    path: '/public/:institutionId/offerings/:offeringId',
    guards: [],
  },
]
